<div class="astral-stack-m">
  <div>
    <astral-button variant="primary" size="small" type="button" icon="plus" [label]="'Efterregistrera överlåtelse'" (click)="createTransfer()"></astral-button>
  </div>
  <p class="help-text">Lägg till ett tidigare kontrakt och överlåtelse för att komplettera med tidigare ägarförhållanden inför kontrolluppgifter.</p>

  <app-list-view
    [columnDefinition]="columnDefinition"
    [itemsSource]="itemsSource"
    [preferencesKey]="'rent.transfer-list.list'"
    (rowClick)="onRowClicked($event)"
  ></app-list-view>
</div>
